import { useContext } from 'react';
import { CustomerInfoContext } from '../../contexts/CustomerInfoContext';
import { DyPageTypeEnum, RevolutionSliderTypes } from '../../enums';
import { SmartNotifications } from '../../widgets/SmartNotifications';
import MktSlideshow from '../Common/Marketing/MktSlideshow';
import NewsletterBannerSmall from '../Common/Marketing/NewsletterBannerSmall';
import NewsletterBannerWide from '../Common/Marketing/NewsletterBannerWide';
import QuizBannerSmall from '../Common/Marketing/QuizBannerSmall';
import QuizBannerWide from '../Common/Marketing/QuizBannerWide';
import PlatformInformation from '../Common/PlatformInformation';
import RecommendedProducts from '../Common/RecommendedProducts';
import { Contest } from './Contest';
import { HomeSaveEveryDay } from './SaveEveryDay';
import { HomeSmartSpending } from './SmartSpending';
import TopDeals from './TopDeals';
import { Shortcuts } from './Shortcuts';
import { CarouselsContext } from '../../contexts/CarouselsProvider';

export default function HomePage() {
  const { customerInfo } = useContext(CustomerInfoContext);
  const { shortcuts, loading } = useContext(CarouselsContext);
  const showNewsletterBanners =
    customerInfo.showNewsletterBanners && !customerInfo.isSavingsUser;
  const showQuizBanners = customerInfo.showQuizBanners;

  // DO NOT DELETE

  // const [showOnboarding, setShowOnboarding] = useState<boolean>(false);

  // const handleOnboardingFinish = async () => {
  //   const response = await customerService.checkOnboarding();
  //   if (!response.hasErrors) {
  //     setCustomerInfo({ ...customerInfo, hasOnboarded: true });
  //   }
  //   setShowOnboarding(false);
  // };

  // useEffect(() => {
  //   setShowOnboarding(customerInfo && customerInfo.hasOnboarded === false);
  // }, [customerInfo]);

  const renderMarketingBanners = () => {
    if (showNewsletterBanners && showQuizBanners) {
      return (
        <div className="marketing-banners-row">
          <QuizBannerSmall />
          <NewsletterBannerSmall />
        </div>
      );
    }

    if (showNewsletterBanners) {
      return <NewsletterBannerWide />;
    }

    if (showQuizBanners) {
      return <QuizBannerWide />;
    }

    return null;
  };

  const marketingBanners = renderMarketingBanners();

  return (
    <>
      <section className="section-main section-main--welcome section-full home-page">
        <div className="container">
          {loading.shortcuts === false &&
            !!shortcuts?.length &&
            shortcuts.length <= 0 && <PlatformInformation />}
          {loading.shortcuts === false &&
            !!shortcuts?.length &&
            shortcuts.length > 0 && <Shortcuts shortcuts={shortcuts} />}
          <HomeSmartSpending />
          <MktSlideshow
            sliderType={RevolutionSliderTypes.HomeSlideshow}
            showDotsOnDesktop={false}
          />
          <Contest />
          <TopDeals />
          <RecommendedProducts pageType={DyPageTypeEnum.Homepage} />
          <HomeSaveEveryDay />
          {marketingBanners && (
            <div className="mkt-cards home-marketing-banners">
              {marketingBanners}
            </div>
          )}
        </div>
      </section>
      <div className="toast-wrapper-bottom">
        <div>
          <SmartNotifications
            productId={null}
            categoryId={null}
            isForHome={true}
          />
        </div>
      </div>
      {/* {showOnboarding && (
        <Dialog
          className="dialog-onboarding"
          showCloseIcon
          closeDialog={() => setShowOnboarding(false)}
        >
          <div className="onboarding-content">
            <Onboarding onOnbordingFinish={handleOnboardingFinish} />
          </div>
        </Dialog>
      )} */}
    </>
  );
}
